import ResponsiveComponent from "../../../../components/common/ResponsiveComponent";
import MobileGiftDetail from "./mobile/MobileGiftDetail";
import WebGiftDetail from "./web/WebGiftDetail";

const GiftDetail = () => {
  return (
    <ResponsiveComponent
      mobileComponent={<MobileGiftDetail />}
      webComponent={<WebGiftDetail />}
    />
  );
};

export default GiftDetail;
